import Vue from 'vue';

import App from './Main.vue';

Vue.component('app', App);

new Vue({
  el: '#App',
  template: '<App/>',
  components: { App },
});


// WEBPACK FOOTER //
// ./src/pages/index.js